import React from 'react'
import Link from 'gatsby-link'

import logo from '../img/logo.svg'

const Footer = props => {
  return (
    <footer id="footer">
      <section>
        <h2>Une question ? Nous contacter</h2>
        <dt>Email</dt>
        <dd>
          <a href="#">{'contact@comparatif-logiciel-association.com'}</a>
        </dd>
      </section>
      <p className="copyright">
        Le site Comparatif-logiciel-association.com est édité par la société [AssoConnect](https://www.assoconnect.com/)
        
       <br/> 
Forme juridique : Société par Actions au capital social de 49.564,30 euros
 <br/> 
Immatriculation RCS de Paris sous le numéro 530 775 576 (numéro TVA intracommunautaire FR57530775576)
 <br/> 
Siège social : 236 Rue du Faubourg Saint-Martin, 75010 Paris
 <br/> 
Responsable de publication : Arnaud de la Taille
 <br/> 
Hébergeur : Gandi
      </p>
    </footer>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js